import {Button, Spin, Table} from 'antd';
import {CoursesService} from './CoursesService';
import {useEffect, useState} from 'react';
import {Course} from '../../graphql/API';
import {Link} from 'react-router-dom';
import Title from 'antd/es/typography/Title';

const coursesService = new CoursesService();

export const CourseTable = () => {
  const [courses, setCourses] = useState<Array<Course> | []>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    coursesService
      .getCoursesWithoutPlan()
      .then((resp) => {
        setIsLoading(false);
        //console.log('courses: ', resp);
        setCourses(resp);
      })
      .catch((error) => {
        setIsError(true);
        console.log('Error ->', error);
      });
  }, []);
  const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    //console.log('params', pagination, filters, sorter, extra);
  };

  const columns = [
    {
      title: 'course ID',
      dataIndex: 'id',
      sorter: (a: any, b: any) => {
        return a.id.localeCompare(b.id);
      },
      sortDirections: ['descend'],
      render: (courseId: string) => (
        <Link to={'/course/' + courseId}>{courseId}</Link>
      ),
    },
    {
      title: 'Level',
      defaultSortOrder: 'ascend',
      dataIndex: ['level', 'name'],
      sorter: (a: any, b: any) => {
        return a.level?.name?.localeCompare(b?.level.name);
      },
    },
    {
      title: 'Language',
      dataIndex: ['language', 'language'],
      sorter: (a: any, b: any) => {
        return a.language.language.localeCompare(b.language.language);
      },
    },

    {
      title: 'Course name',
      dataIndex: 'name',
      sorter: (a: any, b: any) => {
        return a.name.localeCompare(b.name);
      },
    },
  ];

  return (
    <>
      {/* <Button
        size={'large'}
        style={{float: 'right', margin: 20}}
        onClick={() => alert('In progress')}>
        Create
      </Button> */}
      {!isError && !isLoading && (
        <Table
          pagination={{defaultPageSize: 100}}
          expandRowByClick={true}
          //@ts-ignore
          columns={columns}
          dataSource={courses}
          onChange={onChange}
        />
      )}

      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Enrollments fetching error ⚠️</Title>}
    </>
  );
};
